import { api, type Api } from "@api/bot-base-api-request";
import { useMutation } from "@tanstack/react-query";

const BOT_UPDATE_COPY_TRADE_QUERY_KEY = "bot-update-copy-trade";

type BotUpdateCopyTradeParams = {
  chainId: number;
  walletAddress: string;
  copyWallet: string;
  userId: string;
  nickname?: string;
  isAutoSlippage?: boolean;
  slippage?: number;
  isBuyWithFixedAmount?: boolean;
  buyAmount?: string;
  buyAmountPercent?: number;
  isCopySells?: boolean;
  isDuplicateBuys?: boolean;
  isTokenRenounced?: boolean;
  minLiquidity?: number;
  maxLiquidity?: number;
  minTotalVolume?: number;
  maxTotalVolume?: number;
  minMC?: number;
  maxMC?: number;
  minTax?: number;
  maxTax?: number;
  isAutoSell?: boolean;
  isOn?: boolean;
  isDelete?: boolean;
  appPubKey?: any;
};

const postBotUpdateCopyTrade = async (
  api: Api,
  params: BotUpdateCopyTradeParams
) => api.post("copyTrade/update", { json: params }).json();

const useBotUpdateCopyTradeMutation = () =>
  useMutation({
    mutationFn: async (params: BotUpdateCopyTradeParams) => {
      postBotUpdateCopyTrade(api, params);
    },
    mutationKey: [BOT_UPDATE_COPY_TRADE_QUERY_KEY],
  });

export {
  useBotUpdateCopyTradeMutation,
  postBotUpdateCopyTrade,
  BOT_UPDATE_COPY_TRADE_QUERY_KEY,
};
